/**
 * Storage へアップロードするときの contentType を決める。
 *
 * ブラウザ / OS によっては File.type が空（.md / .csv / .ico など）になる。空のまま送ると
 * Firebase SDK は application/octet-stream を付けるため、Storage Rules の許可リストで弾かれる。
 * そこで、type が空または octet-stream のときだけ拡張子から補完する。
 * ※ 拡張子や MIME だけではファイルの実体は保証できない（Rules の許可リストは誤アップロード防止が目的）。
 */
const EXT_TO_MIME: Record<string, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  ico: 'image/x-icon',
  pdf: 'application/pdf',
  txt: 'text/plain',
  md: 'text/markdown',
  csv: 'text/csv',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  mp4: 'video/mp4',
  mov: 'video/quicktime',
  webm: 'video/webm',
};

export const extensionOf = (fileName: string): string => {
  const i = fileName.lastIndexOf('.');
  return i >= 0 ? fileName.slice(i + 1).toLowerCase() : '';
};

export function resolveUploadContentType(file: { name: string; type?: string }): string | undefined {
  const type = (file.type || '').toLowerCase();
  if (type && type !== 'application/octet-stream') return type;
  const fromExt = EXT_TO_MIME[extensionOf(file.name)];
  return fromExt ?? (type || undefined);
}

/** Storage のオブジェクト名に使えるように、制御文字とパス区切りを除去する。 */
export function sanitizeStorageFileName(name: string): string {
  return name.replace(/[\u0000-\u001f<>:"/\\|?*]+/g, '').slice(0, 200) || 'file';
}
